import styled from '@emotion/styled';

export const MainContainer = styled.div`
  width: 100%;
  margin: 30px;
`;
